import EventEmitter from 'eventemitter3';

const eventemitter = new EventEmitter();

export default eventemitter;
